import type { DataTableHeader } from '@/types/vuetify';

export function createToolUserDetailsPageHeaders(): DataTableHeader[] {
    const { t } = useI18n();

    return [
        {
            title: t('toolUserDetails.columns.login'),
            value: 'login',
            key: 'login',
            sortable: true,
            nowrap: true,
            minWidth: 100,
        },
        {
            title: t('toolUserDetails.columns.date'),
            value: 'created_at',
            key: 'created_at',
            sortable: true,
            nowrap: true,
            minWidth: 100,
        },
        {
            title: t('toolUserDetails.columns.name'),
            value: 'name',
            key: 'name',
            sortable: true,
            nowrap: true,
            minWidth: 120,
        },
        {
            title: t('toolUserDetails.columns.surname'),
            value: 'surname',
            key: 'surname',
            sortable: true,
            nowrap: true,
            minWidth: 120,
        },
        {
            title: t('toolUserDetails.columns.email'),
            value: 'email',
            key: 'email',
            sortable: true,
            nowrap: true,
            minWidth: 180,
        },
        {
            title: t('toolUserDetails.columns.agent'),
            value: 'user_owner_login',
            key: 'user_owner_login',
            sortable: true,
            nowrap: true,
            minWidth: 100,
        },
        {
            title: t('toolUserDetails.columns.country'),
            value: 'country_id',
            key: 'country_id',
            sortable: true,
            nowrap: true,
            minWidth: 100,
        },
        {
            title: t('toolUserDetails.columns.currency'),
            value: 'currency_id',
            key: 'currency_id',
            sortable: true,
            nowrap: true,
            minWidth: 70,
        },
        {
            title: t('toolUserDetails.columns.refUser'),
            value: 'user_ref_name',
            key: 'user_ref_name',
            sortable: true,
            nowrap: true,
            minWidth: 90,
        },
        {
            title: t('toolUserDetails.columns.idProof'),
            tooltip: t('toolUserDetails.tooltips.column.idProof'),
            value: 'is_id_proof',
            key: 'is_id_proof',
            align: 'center',
            sortable: false,
            minWidth: 70,
            nowrap: true,
            width: 70,
        },
        {
            title: t('toolUserDetails.columns.validIdDoc'),
            tooltip: t('toolUserDetails.tooltips.column.validIdDoc'),
            value: 'is_valid_id',
            key: 'is_valid_id',
            align: 'center',
            sortable: false,
            nowrap: true,
            minWidth: 80,
        },
        {
            title: t('toolUserDetails.columns.utilityProof'),
            tooltip: t('toolUserDetails.tooltips.column.utilityProof'),
            value: 'is_utility_proof',
            key: 'is_utility_proof',
            align: 'center',
            sortable: false,
            nowrap: true,
            minWidth: 70,
            width: 70,
        },
        {
            title: t('toolUserDetails.columns.validUtilityDoc'),
            tooltip: t('toolUserDetails.tooltips.column.validUtilityDoc'),
            value: 'is_valid_utility',
            key: 'is_valid_utility',
            align: 'center',
            sortable: false,
            nowrap: true,
            minWidth: 90,
        },
        {
            title: t('toolUserDetails.columns.documents'),
            value: 'documents',
            key: 'documents',
            align: 'center',
            sortable: false,
            nowrap: true,
            minWidth: 90,
        },
        {
            title: t('toolUserDetails.columns.sendEmail'),
            tooltip: t('toolUserDetails.tooltips.column.sendEmail'),
            value: 'documents_approve_mailed_at',
            key: 'documents_approve_mailed_at',
            align: 'center',
            sortable: false,
            nowrap: true,
            minWidth: 110,
        },
        {
            title: '',
            value: 'actions',
            key: 'actions',
            align: 'end',
            sortable: false,
            nowrap: true,
            width: 72,
            cellProps: { class: 'pl-0 pr-1' },
        },
    ];
}
